import { debounce, cloneDeep, pick } from "lodash";

import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import EditDetailsForm from "../../forms/EditDetailsForm.jsx";
import ResourceDetailsView from "./ResourceDetailsView.jsx";
import withBasicForm from "/components/forms/withBasicForm.js";
import EditButton from "../../forms/EditButton.jsx";
import ProjectWizardSteppedForm from "../../projectWizard/ProjectWizardSteppedForm.jsx";

import { OPERATIONS } from "/constants/operations.js";
import { VIEW_MODES } from "/constants/modes.js";
import { AT_TYPES_TO_RESOURCE_KEYS } from "../../../constants/entity.js";

import estimateSelector from "../../../state/reducers/estimates/estimateSelector.js";
import { selectOperationAvailability } from "/state/reducers/operations/operationSelector.js";
import { projectWizardUpdateEstimate } from "../../../state/reducers/projectWizard/projectWizardActions.js";
import { selectCopy } from "/state/reducers/locale/copySelector.js";

const BasicEditDetailsForm = withBasicForm(EditDetailsForm);

class ResourceDetailsPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    doEdit: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,

    estimateIsAvailable: PropTypes.bool,
    updateResourceAvailability: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "resource.details_panel"
  };

  constructor(props) {
    super(props);

    this.schedules = ["office"];

    this.state = {
      mode: VIEW_MODES.DISPLAY
    };
  }

  // -- EVENT HANDLERS -- //

  onEdit = () => {
    this.setState({ mode: VIEW_MODES.EDIT });
  };

  onCancel = () => {
    this.setState({ mode: VIEW_MODES.DISPLAY });
  };

  onSubmit = values => {
    this.props.doEdit(values);
  };

  doEstimate = (prevFormikProps, formikProps) => {
    const { data } = this.props;

    const baseResource = pick(data, [
      "@type",
      "description",
      "name",
      "region",
      "rootVolumeSize",
      "rootVolumeCount",
      "schedules",
      "service",
      "image"
    ]);

    // todo" not sure why this is different when a image has been deleted vs. not,
    // in the API resource get it's always the same: "image": "/images/{id}"
    var imageId;

    if (data.image.hasOwnProperty("@id")) {
      imageId = data.image["@id"];
    } else {
      imageId = data.image;
    }

    const currentResource = cloneDeep(baseResource);
    currentResource.image = imageId;
    currentResource.region = data.region["@id"];
    currentResource.schedules = this.schedules;
    currentResource.size = data.size["@id"];

    const updatedResource = cloneDeep(currentResource);
    updatedResource.image = imageId;
    updatedResource.size = formikProps.values.size;

    // -- Estimate call logic
    if (formikProps.values.ignoreChangeInSideEffect !== true) {
      const resourceKey = AT_TYPES_TO_RESOURCE_KEYS[currentResource["@type"]];

      this.props.updateEstimate(
        {
          "@id": "current",
          [resourceKey]: [currentResource]
        },
        this.schedules
      );

      this.props.updateEstimate(
        {
          "@id": "updated",
          [resourceKey]: [updatedResource]
        },
        this.schedules
      );
    }
  };

  debounceEstimateChange = debounce(
    this.doEstimate,
    ProjectWizardSteppedForm.ESTIMATE_DEBOUNCE
  );

  // -- RENDER -- //

  renderPanelView() {
    if (this.state.mode === VIEW_MODES.EDIT) {
      const onChange = this.props.estimateIsAvailable
        ? this.debounceEstimateChange
        : undefined;

      return (
        <BasicEditDetailsForm
          {...this.props}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onChange={onChange}
        />
      );
    } else {
      return <ResourceDetailsView {...this.props} className="clear-both" />;
    }
  }

  render() {
    const { mode } = this.state;
    const {
      data,
      disabled,
      copyKey,
      copy,
      updateResourceAvailability: { available }
    } = this.props;

    if (!data) return null;

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3" floated="left">
          {copy(`${copyKey}.details`)}
        </Header>
        {available && (
          <EditButton
            mode={mode}
            floated="right"
            disabled={disabled}
            onClick={this.onEdit}
          />
        )}
        <span className="clearfix"></span>
        {this.renderPanelView()}
      </Segment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  estimateIsAvailable: estimateSelector.selectEstimateIsAvailabile(
    state,
    props
  ),
  updateResourceAvailability: selectOperationAvailability(
    state,
    props,
    OPERATIONS.UPDATE
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  updateEstimate: (data, schedules, project) =>
    dispatch(projectWizardUpdateEstimate(data, schedules, project))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceDetailsPanel);
